import { CheckSquareIcon, SquareIcon } from 'lucide-react'

export const CheckStateIcon = ({ isActive }: { isActive: boolean }) => {
	if (isActive) {
		return <CheckSquareIcon className='text-primary !size-6 shrink-0' />
	}

	return <SquareIcon className='text-foreground/70 !size-6 shrink-0' />
}
